import React, { useEffect } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import Spinner from 'react-bootstrap/Spinner';
import { Button } from 'v3/components';
import { styles } from './styles';

export default function CloseLinkChecklistModal({
  open = false,
  onClose,
  onConfirm,
  checklistTitle = '',
  responsesCount = 0,
  loading = false,
  loadingLabel = 'Encerrando...',
  isLinkClosed = false,
}) {
  const disableConfirm = loading || !!isLinkClosed;

  useEffect(() => {
    if (!open) return undefined;

    function onEsc(event) {
      if (event.key === 'Escape' && !loading && onClose) onClose();
    }

    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [open, onClose, loading]);

  if (!open) return null;

  return (
    <div
      style={styles.overlay}
      role="presentation"
      onMouseDown={event => {
        if (event.target === event.currentTarget && !loading && onClose)
          onClose();
      }}
      aria-busy={loading ? 'true' : 'false'}
    >
      <div style={styles.modal} role="dialog" aria-modal="true">
        <div style={styles.header}>
          <div style={styles.titleRow}>
            <span style={styles.iconWarnWrap}>
              <WarningAmberOutlinedIcon
                style={{ fontSize: 18, color: '#B45309' }}
              />
            </span>
            Encerrar Treinamento
          </div>

          <button
            type="button"
            style={{
              ...styles.closeBtn,
              ...(loading ? styles.closeBtnDisabled : null),
            }}
            onClick={() => !loading && onClose && onClose()}
            aria-label="Fechar"
            disabled={loading}
            title={loading ? 'Aguarde...' : 'Fechar'}
          >
            <CloseOutlinedIcon style={{ fontSize: 18, color: '#6B7280' }} />
          </button>
        </div>

        <div style={styles.body}>
          <div style={styles.description}>
            Tem certeza que deseja encerrar este treinamento? O link de
            compartilhamento será desativado e nenhuma nova resposta poderá ser
            recebida.
          </div>

          <div style={styles.preview}>
            <div style={styles.previewTitle}>{checklistTitle}</div>
            <div style={styles.previewSub}>
              {responsesCount}{' '}
              {responsesCount === 1
                ? 'resposta recebida'
                : 'respostas recebidas'}
            </div>
          </div>

          {isLinkClosed && (
            <div style={styles.warnBox}>
              <HighlightOffOutlinedIcon
                style={{
                  fontSize: 18,
                  color: '#DC2626',
                  flexShrink: 0,
                }}
              />
              <div style={styles.warnText}>Este link está encerrado.</div>
            </div>
          )}
        </div>

        <div style={styles.footer}>
          <Button variant="secondary" disabled={loading} onClick={onClose}>
            Cancelar
          </Button>

          <Button
            variant="danger"
            loading={loading}
            onClick={() => {
              if (disableConfirm) return;
              if (onConfirm) onConfirm();
            }}
            disabled={disableConfirm}
            title={isLinkClosed ? 'Link encerrado' : 'Encerrar checklist'}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: 8 }}
                />
                {loadingLabel}
              </>
            ) : (
              <>
                <HighlightOffOutlinedIcon
                  style={{ fontSize: 18, marginRight: 6 }}
                />
                Encerrar Treinamento
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
